import { GatsbyImageProps, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import Image from "../GatsbyImage";

export type Props = GatsbyImageProps & {
  summary: string;
  image: IGatsbyImageData;
};

export default function BackgroundImage({
  image,
  alt = "",
  summary,
  ...rest
}: Props) {
  return (
    <div className="relative overflow-hidden">
      <Image
        image={image}
        alt={alt}
        className="inset-0 brightness-50 grayscale-50"
        style={{
          position: "absolute",
        }}
        {...rest}
      />
      <span className="relative block summary-background-text">{summary}</span>
    </div>
  );
}
